import CIMSFormItem from 'components/CIMSFormItem'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { HelpMessage } from 'utils/constants'
import CIMSSection from 'components/CIMSSection'
import { IFINotificationEvent } from '@cims-online/shared'
import FrequencyFormItems from '../FrequencyFormItems'
import TypeFormItems from '../TypeFormItems'

const RenderFormItems: React.VFC = () => {
  const { event } = useCIMSNotificationsPanelContext()

  return (
    <>
      <CIMSSection
        title={`Every ${event.name} Event`}
        help={HelpMessage.Notifications.Every(event, 'Identified Field Issue')}
      >
        <CIMSFormItem label="Recipients" name="every">
          <RecipientsSelect />
        </CIMSFormItem>
      </CIMSSection>
      {event === IFINotificationEvent.IssueSummarized ? (
        <FrequencyFormItems />
      ) : (
        <CIMSSection
          title="Types"
          help={HelpMessage.IdentifiedFieldIssues.Notifications.ByIFIType(
            event
          )}
        >
          <CIMSFormItem name="types">
            <TypeFormItems />
          </CIMSFormItem>
        </CIMSSection>
      )}
    </>
  )
}

export default RenderFormItems
